(function() { module.exports = this["wp"]["blockSerializationDefaultParser"]; }());